import { TFunc } from 'libs/i18n';

import { UserItem } from '../types';

export const renderStatus = (t: TFunc, item: UserItem) =>
  t(`onboarding.waitingKyc.users.statuses.${item.status}`);
